import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { RawMaterialDtoExtend } from "@root/user/src/app/view/neq/pages/rawmaterials/rawmaterials-list.page";

@Component({
    templateUrl: './rawmaterials-multi-edit-error-popin.component.html'
  })
  export class RawmaterialsMultiEditErrorPopinComponent implements OnInit {

    rawMaterialsOnErrorStatus: RawMaterialDtoExtend[];
    rawMaterialsOnErrorLock: RawMaterialDtoExtend[]
    
    constructor(
      private readonly dialogRef: MatDialogRef<RawmaterialsMultiEditErrorPopinComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {
        rawMaterialsOnErrorStatus: RawMaterialDtoExtend[],
        rawMaterialsOnErrorLock: RawMaterialDtoExtend[]
      }) {

      }

    ngOnInit(): void {
        this.rawMaterialsOnErrorStatus = this.data.rawMaterialsOnErrorStatus;
        this.rawMaterialsOnErrorLock = this.data.rawMaterialsOnErrorLock;
    }

    closeDialog(res: boolean) {
     this.dialogRef.close(res);
   }
  }